import React from 'react';
import * as IconsSolid from '@heroicons/react/solid';
import * as IconsOutline from '@heroicons/react/outline';

type TDynamicHeroIconProps = {
  icon: string;
  className?: string;
  weight?: 'solid' | 'outline';
};

export const DynamicHeroIcon: React.FC<TDynamicHeroIconProps> = ({
  icon,
  className = '',
  weight = 'solid'
}) => {
  // eslint-disable-next-line
  const Icon: JSX.Element =
    // @ts-ignore
    weight === 'solid' ? IconsSolid[icon] : IconsOutline[icon];

  if (!icon || !Icon) {
    const FallbackIcon =
      weight === 'solid'
        ? IconsSolid.QuestionMarkCircleIcon
        : IconsOutline.QuestionMarkCircleIcon;

    return <FallbackIcon aria-hidden="true" className={className} />;
  }

  return (
    <>
      {/* @ts-ignore */}
      <Icon aria-hidden="true" className={className} />
    </>
  );
};

DynamicHeroIcon.defaultProps = {
  className: undefined,
  weight: undefined
};
